import {
  SET_TESTS_LOADING,
  SET_TESTS_LIST,
  SET_TESTS_ERROR,
  SET_TEST_DETAILS_LOADING,
  SET_TEST_DETAILS,
  SET_TEST_DETAILS_ERROR,
  RESET_TEST_DETAILS,
  SET_REPORTS_LOADING,
  SET_REPORTS_LIST,
  SET_REPORTS_ERROR,
  SET_LATEST_REPORT_LOADING,
  SET_LATEST_REPORT,
  SET_LATEST_REPORT_ERROR,
  RESET_LATEST_REPORT,
} from "./constants";

const initialState = {
  // All tests list state
  tests: {
    data: null,
    loading: false,
    error: null,
  },
  // Test details (reports for a specific test) state
  testDetails: {
    data: null,
    loading: false,
    error: null,
  },
  // Reports list state
  reports: {
    data: null,
    loading: false,
    error: null,
  },
  // Latest report state
  latestReport: {
    data: null,
    loading: false,
    error: null,
  },
};

export default function performanceTestsReducer(state = initialState, action) {
  switch (action.type) {
    // Tests list actions
    case SET_TESTS_LOADING:
      return {
        ...state,
        tests: {
          ...state.tests,
          loading: action.payload,
        },
      };

    case SET_TESTS_LIST:
      return {
        ...state,
        tests: {
          ...state.tests,
          data: action.payload,
          loading: false,
        },
      };

    case SET_TESTS_ERROR:
      return {
        ...state,
        tests: {
          ...state.tests,
          error: action.payload,
          loading: false,
        },
      };

    // Test details actions
    case SET_TEST_DETAILS_LOADING:
      return {
        ...state,
        testDetails: {
          ...state.testDetails,
          loading: action.payload,
        },
      };

    case SET_TEST_DETAILS:
      return {
        ...state,
        testDetails: {
          ...state.testDetails,
          data: action.payload,
          loading: false,
        },
      };

    case SET_TEST_DETAILS_ERROR:
      return {
        ...state,
        testDetails: {
          ...state.testDetails,
          error: action.payload,
          loading: false,
        },
      };

    case RESET_TEST_DETAILS:
      return {
        ...state,
        testDetails: {
          ...initialState.testDetails,
        },
      };

    // Reports list actions
    case SET_REPORTS_LOADING:
      return {
        ...state,
        reports: {
          ...state.reports,
          loading: action.payload,
        },
      };

    case SET_REPORTS_LIST:
      return {
        ...state,
        reports: {
          ...state.reports,
          data: action.payload,
          loading: false,
        },
      };

    case SET_REPORTS_ERROR:
      return {
        ...state,
        reports: {
          ...state.reports,
          error: action.payload,
          loading: false,
        },
      };

    // Latest report actions
    case SET_LATEST_REPORT_LOADING:
      return {
        ...state,
        latestReport: {
          ...state.latestReport,
          loading: action.payload,
        },
      };

    case SET_LATEST_REPORT:
      return {
        ...state,
        latestReport: {
          ...state.latestReport,
          data: action.payload,
          loading: false,
        },
      };

    case SET_LATEST_REPORT_ERROR:
      return {
        ...state,
        latestReport: {
          ...state.latestReport,
          error: action.payload,
          loading: false,
        },
      };

    case RESET_LATEST_REPORT:
      return {
        ...state,
        latestReport: {
          ...initialState.latestReport,
        },
      };

    default:
      return state;
  }
}
